import React from 'react';
import { FaFilePdf } from 'react-icons/fa';

const DOCUMENTOS_PADRAO = [
  { key: 'autorizacao', label: 'Autorização de Escritura' },
];

const DisplayDocumentosEscritura = ({ codigoBoleto, abas, titulo }) => {
  var documentos = abas || DOCUMENTOS_PADRAO;

  function abrirDocumento(tipo) {
    var url = '/autoatendimento/escritura/solicitacoes/' + codigoBoleto + '/documento-digital/' + tipo;
    window.open('/visualizar-pdf?url=' + encodeURIComponent(url), '_blank');
  }

  return (
    <section className="my-3">
      {titulo && <h5>{titulo}</h5>}
      <ul className="list-group">
        {documentos.map(function (doc) {
          return (
            <li
              key={doc.key}
              className="list-group-item list-group-item-action d-flex align-items-center"
              style={{ cursor: 'pointer' }}
              onClick={function () { abrirDocumento(doc.key); }}
            >
              <FaFilePdf color="#dc3545" size={20} className="mr-3" />
              <span>{doc.label}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default DisplayDocumentosEscritura;
